import mitt from "mitt"

// Types des événements (préserver la logique métier existante)
type Events = {
  "open-profile-modale": { show: boolean; id?: string }
  "sub-title-edited": string
  "project-saved": void
  "main-title-changed": string
  "sub-title-changed": string
  "sub-title-icon-changed": string
  "sub-title-is-editable-changed": boolean
  "display-sub-title-in-green-changed": boolean
  "contextual-menu-changed": any // ContextMenu type
  "contextual-menu-anchor-update": string
  "input-dirty": void
}

// Instance globale du bus d'événements
export const eventBus = mitt<Events>()

// Helper pour compatibilité avec l'ancien système
export const EventBusService = {
  emit: eventBus.emit,
  on: eventBus.on,
  off: eventBus.off,
}
